import React, { useEffect } from 'react';
import { Row } from 'antd';
import { connect } from 'react-redux';
import moment from 'moment';

import * as courseSelectors from '../../redux/selectors/course';
import * as authSelectors from '../../redux/selectors/auth';
import * as heroBannerSelectors from '../../redux/selectors/heroBanner';
import { actions as courseActions } from '../../redux/modules/course';
import { actions as heroBannerActions } from '../../redux/modules/heroBanner';

import MainLayout from '../../components/MainLayout';
import HeaderInside from '../../components/HeaderInside';
import CourseCard from './components/CourseCard.component';
import HeroBanner from '../../components/HeroBanner';
import PromotionalVideoPopup from '../../components/PromotionalVideoPopup';
import PropTypes from 'prop-types';

import CourseListEmpty from './components/CourseListEmpty';

import {
  Container,
  PrincipalSection,
  PrincipalBadge,
  CoursesSection,
  AdditionalHeader,
} from './styles';
import star from '../../img/svg/star.svg';
import { useNotifications } from 'contexts/notifications';

const TIPO_CURSO_PRINCIPAL = 'principal';

const propTypes = {
  getCoursesByUserId: PropTypes.func.isRequired,
  fetchPodcast: PropTypes.func.isRequired,
  userId: PropTypes.any.isRequired,
  enrollmentsList: PropTypes.array,
  isLoading: PropTypes.bool.isRequired,
  getHeroBanners: PropTypes.func.isRequired,
  heroBanners: PropTypes.array,
};
function CourseList({
  getCoursesByUserId,
  isLoading,
  enrollmentsList,
  getHeroBanners,
  heroBanners
}) {
  const {getNotifications} = useNotifications();

  useEffect(() => {
    getCoursesByUserId();
    getNotifications(1);
    getHeroBanners();
    // Intencionalmente executado só na montagem; funções Redux são estáveis via connect
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const courses = Array.isArray(enrollmentsList) ? enrollmentsList : [];
  const isInitialLoading = isLoading && courses.length === 0;

  const visibleCourses = courses.filter((course) => {
    let isOpenCourseClass = true;
    if (course?.data_fim_aulas) {
      const dataFim = moment(course.data_fim_aulas, 'YYYY-MM-DD').add(1, 'days').format('YYYY/MM/DD');
      const dataAtual = moment().format('YYYY/MM/DD');
      isOpenCourseClass = moment(dataFim).isAfter(dataAtual);
    }

    return isOpenCourseClass && course?.is_visible;
  });

  const principalCourses = visibleCourses.filter((course) => course?.tipo_curso === TIPO_CURSO_PRINCIPAL);
  const additionalCourses = visibleCourses.filter((course) => course?.tipo_curso !== TIPO_CURSO_PRINCIPAL);

  return (
    isInitialLoading ? <CourseListEmpty /> : (
        <MainLayout title='Meus cursos' className="home">
            <PromotionalVideoPopup />
            <Container>
              <HeroBanner banners={heroBanners} />
              <HeaderInside title='Meus cursos' />

              {principalCourses.length > 0 && (
                <PrincipalSection>
                  <PrincipalBadge>
                    <img src={star} alt="" />
                    <span>Principal</span>
                  </PrincipalBadge>
                  <Row gutter={15}>
                    {principalCourses.map((course, index) => (
                      <CourseCard
                        key={course?.id_turma ? `${course.id_curso}-${course.id_turma}` : `principal-course-${index}`}
                        course={course}
                      />
                    ))}
                  </Row>
                </PrincipalSection>
              )}

              {additionalCourses.length > 0 && (
                <CoursesSection>
                  {principalCourses.length > 0 && (
                    <AdditionalHeader>
                      <span>Cursos adicionais</span>
                    </AdditionalHeader>
                  )}
                  <Row gutter={15}>
                    {additionalCourses.map((course, index) => (
                      <CourseCard
                        key={course?.id_turma ? `${course.id_curso}-${course.id_turma}` : `additional-course-${index}`}
                        course={course}
                      />
                    ))}
                  </Row>
                </CoursesSection>
              )}
            </Container>
        </MainLayout>
    )
  );
}

const mapStateToProps = (state, props) => {
   return {
    enrollmentsList: courseSelectors.getEnrollmentsList(state, props),
    isLoading: courseSelectors.isLoading(state, props),
    userId: authSelectors.getUser(state, props).id,
    heroBanners: heroBannerSelectors.getHeroBanners(state),
  };

};

const mapDispatchToProps = (dispatch) => ({
  getCoursesByUserId: (next, error) => dispatch(courseActions.getCoursesByUserId(next, error)),
  getHeroBanners: () => dispatch(heroBannerActions.getHeroBanners()),
});

CourseList.propTypes = propTypes;
export default connect(mapStateToProps, mapDispatchToProps)(CourseList);
